import React from "react";
import TestList from "./TestsList";

const AppointmentList = () => {
  return (
   <TestList isAppointment={true} />
  );
};


export default AppointmentList;
